import React, { useEffect, useState } from 'react'
import useStyles from "./style"
import { Link, useLocation } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Container, Grid, TextField, Typography } from '@mui/material';
import HeaderImg from '@assets/images/Popup/HeaderPopup.png';
import CenterImg from '@assets/images/Popup/CenterPopup.png';
import BottomImg from '@assets/images/Popup/BottomPopup.png';
import baseApi from '@redux/Popup/api';
import CkeditorComp from '@components/common/ckeditor/Ckeditor';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { DEFAULT_POPUP_TYPES } from '@constants/popupTypes';
export const HeaderPopupPage = (child)=>{
    const classes = useStyles();
    return(
        <div className={classes.header}>
            <Link to={child.path}>
                <div className={classes.wrapIconClose}>
                        <IconButton className={classes.drawIconClose}>
                            {/* <img src={closeIcon} alt="closeIcon" /> */}
                            <ArrowBackIcon className={classes.drawIconClose} />
                        </IconButton>
                        <span className={classes.textClose}>Thoát</span>
                </div>
            </Link>
        </div>
    )
    
}
const CreatePopup = ()=>{
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const selectedType = searchParams.get('type') || '';
    const editId = searchParams.get('id') || '';
    const [popupTypes, setPopupTypes] = useState([]);
    const [newTypeName, setNewTypeName] = useState('');
    const [typeError, setTypeError] = useState('');

    const loadPopupTypes = async () => {
        try {
            const response = await baseApi.fetchPopupTypes();
            const types = response?.data || [];
            setPopupTypes(types.length > 0 ? types : DEFAULT_POPUP_TYPES);
            setTypeError('');
        } catch (error) {
            setPopupTypes(DEFAULT_POPUP_TYPES);
            setTypeError('');
        }
    };

    useEffect(()=>{ 
        loadPopupTypes();
    },[])
    const classes = useStyles();
    const popupImageByType = {
        Headline: HeaderImg,
        Center: CenterImg,
        Bottom: BottomImg
    };
    const popupDescriptionByType = {
        Headline: 'Thanh thông báo gọn ở đầu trang, phù hợp tin tức và ưu đãi ngắn.',
        Center: 'Thu hút sự chú ý ở trung tâm màn hình cho chiến dịch quan trọng.',
        Bottom: 'Hiển thị nhẹ nhàng ở cuối trang, ít làm gián đoạn trải nghiệm.'
    };

    const handleCreateType = async () => {
        const label = newTypeName.trim();
        if (!label) {
            setTypeError('Vui lòng nhập tên loại popup');
            return;
        }
        try {
            const response = await baseApi.createPopupType({ label });
            setNewTypeName('');
            setTypeError('');
            await loadPopupTypes();
            const createdName = response?.data?.name || label;
            window.location.href = `/admin/create-popup?type=${encodeURIComponent(createdName)}`;
        } catch (error) {
            setTypeError(error?.response?.data?.message || 'Không tạo được loại popup');
        }
    };

    const handleDeleteType = async (event, type) => {
        event.preventDefault();
        event.stopPropagation();
        try {
            await baseApi.deletePopupType(type._id || type.name);
            await loadPopupTypes();
        } catch (error) {
            setTypeError(error?.response?.data?.message || 'Không xoá được loại popup');
        }
    };

    if (selectedType || editId) {
        const title = selectedType ? `Popup ${selectedType}` : 'Popup';
        return (
            <>
                <HeaderPopupPage path="/admin/popup-management"/>
                <div className={classes.editorRoot}>
                    <CkeditorComp
                        title={title}
                        content="Cấu hình nội dung, lịch chạy và phạm vi quốc gia hiển thị."
                        popupType={selectedType}
                    />
                </div>
            </>
        )
    }

    return (
        <>  
            <>
                <HeaderPopupPage path="/admin/popup-management"/>
                <div className={classes.root}>
                    <Container maxWidth="lg">
                        <div className={classes.selectionHero}>
                            <span className={classes.eyebrow}>TẠO POPUP MỚI</span>
                            <Typography component="h1" className={classes.selectionTitle}>
                                Chọn kiểu hiển thị
                            </Typography>
                            <Typography className={classes.selectionDescription}>
                                Bắt đầu với một bố cục phù hợp. Bạn vẫn có thể đổi loại popup trong bước chỉnh sửa.
                            </Typography>
                        </div>

                        <Grid container spacing={3} alignItems='stretch'>
                            {popupTypes.map((value, index)=>{
                                const image = popupImageByType[value.name];
                                return (
                                    <Grid item key={value._id || value.name || index} xs={12} sm={6} md={4}>
                                        <Link to={`/admin/create-popup?type=${encodeURIComponent(value.name)}`} style={{ textDecoration: 'none' }}>
                                            <div className={classes.choiceCard}>
                                                <div className={classes.choicePreview}>
                                                    {image ? (
                                                        <img className={classes.imgProp} src={image} alt={value.label || value.name}/>
                                                    ) : (
                                                        <WidgetsOutlinedIcon className={classes.customTypeIcon}/>
                                                    )}
                                                    <span className={classes.typeBadge}>
                                                        {value.locked ? 'Mặc định' : 'Tuỳ chỉnh'}
                                                    </span>
                                                </div>
                                                <div className={classes.choiceContent}>
                                                    <div>
                                                        <Typography className={classes.typeTitle}>{value.label || value.name}</Typography>
                                                        <Typography className={classes.typeDescription}>
                                                            {popupDescriptionByType[value.name] || 'Bố cục tuỳ chỉnh dành riêng cho chiến dịch của bạn.'}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.choiceFooter}>
                                                        <span>Chọn bố cục</span>
                                                        <ArrowForwardRoundedIcon/>
                                                    </div>
                                                </div>
                                                {!value.locked && (
                                                    <IconButton
                                                        className={classes.deleteTypeButton}
                                                        aria-label={`Xoá loại ${value.label || value.name}`}
                                                        onClick={(event) => handleDeleteType(event, value)}
                                                    >
                                                        <DeleteOutlineRoundedIcon/>
                                                    </IconButton>
                                                )}
                                            </div>
                                        </Link>
                                    </Grid>
                                )
                            })}
                        </Grid>

                        <div className={classes.createTypeCard}>
                            <div className={classes.createTypeHeading}>
                                <span className={classes.createTypeIcon}><AddRoundedIcon/></span>
                                <div>
                                    <Typography className={classes.createTypeTitle}>Cần một loại popup riêng?</Typography>
                                    <Typography className={classes.createTypeDescription}>
                                        Tạo loại mới và bắt đầu cấu hình ngay.
                                    </Typography>
                                </div>
                            </div>
                            <div className={classes.createTypeForm}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Tên loại popup"
                                    placeholder="Ví dụ: Floating banner"
                                    value={newTypeName}
                                    onChange={(event) => setNewTypeName(event.target.value)}
                                />
                                <Button variant="contained" onClick={handleCreateType} startIcon={<AddRoundedIcon/>}>
                                    Tạo loại mới
                                </Button>
                            </div>
                        </div>

                        {typeError && (
                            <Typography color="error" align="center" sx={{ marginTop: '14px' }}>
                                {typeError}
                            </Typography>
                        )}
                    </Container>
                </div>
            </>
        </>
    )
}
export default CreatePopup;
